import React from 'react'
import OwlIcon from '../../../assets/images/front/svg/owl.svg'
import { Settings } from '../../../services/types'

interface OwlBannerProps {
  settings: Settings
}

const OwlBanner: React.FC<OwlBannerProps> = ({ settings }) => {
  return (
    <>
      {settings?.owl_popup && (
        <div className="fixed xl:right-[120px] 2xl:right-30 bottom-10 p-5 bg-white border border-[#DADADA] rounded-3xl w-[200px] z-50 hidden xl:block">
          <h2 className="font-myriad text-[#00A0E3] text-[22px] leading-tight">
            {settings.owl_popup.title}
          </h2>
          <h3 className="font-myriad font-bold text-[#A8CD00] text-[30px] leading-tight mb-8">
            {settings.owl_popup.subtitle}
          </h3>
          <a
            href={settings.owl_popup.url}
            className="cursor-pointer block text-center uppercase text-white text-[25px] rounded-lg px-5 bg-[#00A0E3] hover:bg-[#0183BA] w-full"
          >
            {settings.owl_popup.button_text}
          </a>
          <img
            src={OwlIcon}
            alt=""
            className="absolute top-[50%] translate-y-[-50%] right-[-55px]"
          />
        </div>
      )}
    </>
  )
}

export default OwlBanner
